module.exports = __webpack_public_path__ + "img/banner-1.17dc0818.png";